<div class="um-wrap">

  <ul class="nav nav-tabs um-tabs" role="tablist">


    <li class="nav-item" role="presentation">
      <a class="nav-link active" id="vm-tab-summary-link"
         data-bs-toggle="tab" href="#vm-tab-summary"
         role="tab" aria-controls="vm-tab-summary" aria-selected="true"
         (shown.bs.tab)="onSummaryTabShown()">
        Task Summary
      </a>
    </li>

    <li class="nav-item" role="presentation">
      <a class="nav-link" id="vm-tab-history-link"
         data-bs-toggle="tab" href="#vm-tab-history"
         role="tab" aria-controls="vm-tab-history" aria-selected="false"
         (shown.bs.tab)="onHistoryTabShown()">
        Task History
      </a>
    </li>

    <li class="nav-item" role="presentation">
      <a class="nav-link" id="vm-tab-cache-link"
         data-bs-toggle="tab" href="#vm-tab-cache"
         role="tab" aria-controls="vm-tab-cache" aria-selected="false">
        Cache Editor
      </a>
    </li>

    <li class="nav-item" role="presentation">
      <a class="nav-link" id="vm-tab-runner-link"
         data-bs-toggle="tab" href="#vm-tab-runner"
         role="tab" aria-controls="vm-tab-runner" aria-selected="false">
        Quick Run
      </a>
    </li>

  </ul>

  <div class="tab-content um-tab-content">

    <div id="vm-tab-summary" class="tab-pane fade show active um-tab-pane"
         role="tabpanel" aria-labelledby="vm-tab-summary-link">
      <div *ngIf="rerunStatus"
           class="alert mx-3 mt-2 mb-0 py-2"
           [class.alert-success]="!rerunError"
           [class.alert-danger]="rerunError">
        {{ rerunStatus }}
      </div>
      <wc-grid #summaryGrid
               [gridKey]="'executionSummary'"
               [contextMenuItems]="summaryMenuItems"
               (contextMenuAction)="onGridAction($event)" />
    </div>

    <div id="vm-tab-history" class="tab-pane fade um-tab-pane"
         role="tabpanel" aria-labelledby="vm-tab-history-link">
      <div *ngIf="rerunStatus"
           class="alert mx-3 mt-2 mb-0 py-2"
           [class.alert-success]="!rerunError"
           [class.alert-danger]="rerunError">
        {{ rerunStatus }}
      </div>
      <wc-grid #historyGrid
               [gridKey]="'executionDetails'"
               [contextMenuItems]="historyMenuItems"
               (contextMenuAction)="onGridAction($event)" />
    </div>

    <div id="vm-tab-cache" class="tab-pane fade um-tab-pane"
         role="tabpanel" aria-labelledby="vm-tab-cache-link">
      <app-cache class="um-child-fill" />
    </div>

    <div id="vm-tab-runner" class="tab-pane fade um-tab-pane"
         role="tabpanel" aria-labelledby="vm-tab-runner-link">
      <div class="qr-layout p-3">
        <div class="qr-form">
          <h5 class="mb-3">Quick Task Runner</h5>
          <p class="text-muted small">
            Queues a scheduled task on demand. Developer use only.
            Results appear in the Task Summary / History tabs.
          </p>

          <div class="mb-3">
            <label class="form-label">Task Type</label>
            <select class="form-select" [(ngModel)]="selectedJobType">
              <option [ngValue]="null">-- select a task type --</option>
              <option *ngFor="let jt of jobTypes" [ngValue]="jt">{{ jt }}</option>
            </select>
          </div>

          <div class="mb-3">
            <label class="form-label">Client (optional)</label>
            <select class="form-select" [(ngModel)]="selectedClientId">
              <option [ngValue]="null">(none)</option>
              <option *ngFor="let c of clients" [ngValue]="c.clientId">{{ c.displayName }}</option>
            </select>
          </div>

          <div class="mb-3">
            <label class="form-label">Job Key (optional)</label>
            <input type="text" class="form-control" [(ngModel)]="jobKeyInput"
                   placeholder="optional routing key" />
          </div>

          <button type="button" class="btn btn-primary"
                  [disabled]="!selectedJobType || queuing"
                  (click)="queueTask()">
            {{ queuing ? 'Queuing...' : 'Queue Task' }}
          </button>

          <div *ngIf="statusMessage"
               class="alert mt-3"
               [class.alert-success]="!statusError"
               [class.alert-danger]="statusError">
            {{ statusMessage }}
          </div>
        </div>

        <aside class="qr-history">
          <div class="qr-history__header">
            <span class="qr-history__title">Recent Runs</span>
            <button type="button" class="qr-history__clear"
                    *ngIf="history.length > 0"
                    (click)="clearHistory()" title="Clear history">
              Clear
            </button>
          </div>

          <p *ngIf="history.length === 0" class="text-muted small qr-history__empty">
            No recent runs yet. Queue a task to add it here.
          </p>

          <ul class="qr-history__list">
            <li *ngFor="let entry of history; let i = index"
                class="qr-history__item"
                (click)="applyHistoryItem(entry)"
                [title]="'Click to pre-fill the form'">
              <div class="qr-history__main">
                <div class="qr-history__job">{{ entry.jobType }}</div>
                <div class="qr-history__meta">
                  <span *ngIf="entry.clientId">{{ clientDisplayName(entry.clientId) }}</span>
                  <span *ngIf="entry.jobKey" class="qr-history__key">key: {{ entry.jobKey }}</span>
                  <span class="qr-history__time">{{ timeAgo(entry.timestamp) }}</span>
                </div>
              </div>
              <button type="button" class="qr-history__run"
                      [disabled]="queuing"
                      (click)="runHistoryItem(entry, $event)"
                      title="Pre-fill and queue immediately">
                Run
              </button>
              <button type="button" class="qr-history__remove"
                      (click)="removeHistoryItem(i, $event)"
                      title="Remove">
                &times;
              </button>
            </li>
          </ul>
        </aside>
      </div>
    </div>

  </div>

</div>
